import React, { useEffect, useRef, useState } from "react";

import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { useAppSelector } from "../../../store/reducers";
import { NavButton } from "../NavButton";
import { Step } from "../constants";
import { ISelections } from "../models";

import styles from "./index.module.scss";

const SELECTION_DATA: {
    [key in Step]?: keyof ISelections;
} = {
    [Step.SLEEP]: "selectedSleepPosition",
    [Step.HEIGHT]: "selectedHeight",
    [Step.WEIGHT]: "selectedWeight",
    [Step.COOLING]: "selectedCoolness",
    [Step.BUDGET]: "selectedBudget",
};

export const MattressMatchNav = (): React.JSX.Element => {
    const { currentScreen } = useAppSelector((state) => state.mattressmatch.ui);
    const step = Object.values(Step)[currentScreen];

    const navbarRef = useRef<HTMLElement>(null);
    const [isFixed, setIsFixed] = useState(true);

    useEffect(() => {
        const document = getDocument();
        const window = getWindow();
        if (!document || !window) return;

        const footer = document.querySelector(".site-footer");
        if (!footer) {
            return;
        }
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                setIsFixed(!entry.isIntersecting);
            },
            {
                root: null, // viewport
                threshold: 0,
            },
        );
        observer.observe(footer);
        return () => observer.disconnect();
    }, []);

    return (
        <nav
            className={styles.navContainer}
            style={{
                position: isFixed ? "fixed" : "absolute",
                bottom: isFixed ? "50px" : 0, // Adjusted for service footer
            }}
            ref={navbarRef}
        >
            <span className={styles.gradient}></span>
            <div className={styles.nav}>
                <NavButton
                    key={currentScreen}
                    selectionData={SELECTION_DATA[step] || "selectedSize"}
                    step={step}
                />
            </div>
        </nav>
    );
};
